import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "s3_mobile h-100p px-2" }
const _hoisted_9 = { class: "font-normal mb-5" }
const _hoisted_10 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_11 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_12 = { class: "s4_mobile h-100p px-3" }
const _hoisted_13 = {
  key: 0,
  class: "font-normal"
}
const _hoisted_14 = { class: "text-2xl" }
const _hoisted_15 = {
  key: 1,
  class: "font-normal"
}
const _hoisted_16 = { class: "s7_mobile h-100p px-5" }
const _hoisted_17 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_18 = {
  class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
  style: {"width":"100%"}
}
const _hoisted_19 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_20 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_21 = {
  key: 2,
  class: "s20 widget px-6 pt-8 pb-2"
}
const _hoisted_22 = { class: "s10 mt--5-5 flex-right gap-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_25 = { class: "s20 gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_26 = {
  key: 0,
  class: "s20 position-relative overflow-hidden rounded-100 mt-6 mb-10",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.05)"}
}
const _hoisted_27 = { class: "s20 position-relative rounded-100 py-7 px-8" }
const _hoisted_28 = { class: "s10 px-4 my-3" }
const _hoisted_29 = { class: "form-floating w-100 my-5" }
const _hoisted_30 = { class: "form-floating w-100 my-5" }
const _hoisted_31 = { class: "form-floating w-100 my-5" }
const _hoisted_32 = { class: "s10 px-4 my-3" }
const _hoisted_33 = { class: "form-floating w-100 my-5" }
const _hoisted_34 = { class: "form-floating w-100 my-5" }
const _hoisted_35 = { class: "form-floating w-100 my-5" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "s20 flex gap-5" }
const _hoisted_38 = { class: "s7_mobile px-6" }
const _hoisted_39 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_40 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_41 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_42 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_43 = { class: "text-grey-900 my-2" }
const _hoisted_44 = { class: "text-grey-900 my-2" }
const _hoisted_45 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_46 = { class: "text-grey-800" }
const _hoisted_47 = { class: "mb-2 text-grey-800" }
const _hoisted_48 = { class: "s7_mobile px-6" }
const _hoisted_49 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_50 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_51 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_52 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_53 = {
  key: 1,
  class: "font-normal my-2 text-grey-500"
}
const _hoisted_54 = {
  key: 2,
  class: "text-grey-800"
}
const _hoisted_55 = {
  key: 3,
  class: "s20 widget px-6 pt-8 pb-2"
}
const _hoisted_56 = { class: "s20 gap-6 px-4 pb-6 collapse-content active" }
const _hoisted_57 = { class: "s20 flex gap-3 mb-2" }
const _hoisted_58 = { class: "form-field-split my-4" }
const _hoisted_59 = { class: "form-field-floating reactive search sm" }
const _hoisted_60 = { class: "form-field-split my-4" }
const _hoisted_61 = { class: "form-field-floating reactive sm" }
const _hoisted_62 = { class: "form-field-floating reactive sm" }
const _hoisted_63 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_64 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_65 = {
  key: 2,
  class: "s20"
}
const _hoisted_66 = { class: "s13 mt-2" }
const _hoisted_67 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_68 = { class: "secondary-font text-sm text-grey-600 mb-2" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "pagination sm justify-content-left mt-5" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { class: "page-link active" }
const _hoisted_73 = ["disabled"]

import { formatAmount, formatDate } from '@/utils';
    import { useRoute } from 'vue-router';
    import { ref, computed, onMounted, watch } from 'vue';
    import axios from 'axios';
    import moment from 'moment';

    interface Carte {
        id: number;
        alias: string | null;
        numero_masque: string | null;
        bloc4: string | null;
        type: string | null;
        statut: string;
        solde: number;
        expiration_mois: number | null;
        expiration_annee: number | null;
        reference: string | null;
        num_lot: string | null;
        date_retrait: string | null;
        created_at: string | null;
        par_defaut: boolean;
        banque: { id: number; nom: string; slug: string } | null;
    }

    interface Transaction {
        id: number;
        reference: string | null;
        libelle: string | null;
        description: string | null;
        montant: number;
        devise: string | null;
        type: string;
        statut: string;
        categorie_slug: string | null;
        created_at: string | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersCarteView',
  setup(__props) {

    const route = useRoute();
    const user: any = ref(route.meta.user || {});

    const cartes = ref<Carte[]>([]);
    const cartesLoading = ref(false);
    const selectedCarteId = ref<number | null>(null);

    const transactions = ref<Transaction[]>([]);
    const transactionsTotal = ref(0);
    const transactionsLoading = ref(false);
    const txPage = ref(1);
    const txPerPage = ref(25);
    const txReference = ref('');
    const txDateMin = ref('');
    const txDateMax = ref('');

    const blocking = ref(false);
    const retraitForm = ref({
        telephone: '',
        nom: '',
        prenom: '',
        numero_piece: '',
        bloc4: '',
        code_retrait: '',
    });
    const retraitLoading = ref(false);

    const selectedCarte = computed<Carte | null>(() => {
        return cartes.value.find(c => c.id === selectedCarteId.value) || cartes.value[0] || null;
    });

    watch(selectedCarte, (carte) => {
        if (carte?.bloc4) {
            retraitForm.value.bloc4 = `**** **** **** ${carte.bloc4}`;
        } else {
            retraitForm.value.bloc4 = '';
        }
    });

    const totalPages = computed(() => Math.ceil(transactionsTotal.value / txPerPage.value) || 1);

    onMounted(async () => {
        // Recharger les données utilisateur
        if (route.params.id) {
            try {
                const response = await axios.get(`/backoffice/users/get/${route.params.id}`);
                user.value = response.data;
                retraitForm.value.nom = user.value?.nom || '';
                retraitForm.value.prenom = user.value?.prenom || '';
                const kycDocs = user.value?.kyc?.kyc_documents || [];
                const idDoc = kycDocs.find((d: any) => d?.type_document === 'cni_recto' || d?.type_document === 'passeport');
                retraitForm.value.numero_piece = idDoc?.numero || user.value?.numero_piece_identite || '';
            } catch (error: any) {
                console.error('Erreur chargement user:', error);
            }
            await loadCartes();
        }
    });

    async function loadCartes() {
        if (!route.params.id) return;
        cartesLoading.value = true;
        try {
            const response = await axios.get(`/backoffice/users/${route.params.id}/cartes`);
            cartes.value = response.data.cartes || [];
            if (cartes.value.length > 0 && selectedCarteId.value === null) {
                selectedCarteId.value = cartes.value[0].id;
                await loadTransactions();
            }
        } catch (error: any) {
            console.error('Erreur chargement cartes:', error);
        } finally {
            cartesLoading.value = false;
        }
    }

    async function loadTransactions() {
        if (!route.params.id || !selectedCarte.value) return;
        transactionsLoading.value = true;
        try {
            const response = await axios.get(
                `/backoffice/users/${route.params.id}/cartes/${selectedCarte.value.id}/transactions`,
                {
                    params: {
                        reference: txReference.value || undefined,
                        date_min: txDateMin.value || undefined,
                        date_max: txDateMax.value || undefined,
                        page: txPage.value,
                        per_page: txPerPage.value,
                    },
                },
            );
            transactions.value = response.data.data || [];
            transactionsTotal.value = response.data.total || 0;
        } catch (error: any) {
            console.error('Erreur chargement transactions:', error);
        } finally {
            transactionsLoading.value = false;
        }
    }

    async function bloquerCarte() {
        if (!selectedCarte.value || blocking.value) return;
        if (!confirm('Voulez-vous vraiment bloquer cette carte ?')) return;
        blocking.value = true;
        try {
            await axios.post(`/backoffice/users/${route.params.id}/cartes/${selectedCarte.value.id}/bloquer`);
            await loadCartes();
        } catch (error: any) {
            alert(error.response?.data?.message || 'Erreur lors du blocage.');
        } finally {
            blocking.value = false;
        }
    }

    async function retraitCarte() {
        if (!selectedCarte.value || retraitLoading.value) return;
        if (!retraitForm.value.bloc4 || !retraitForm.value.code_retrait || !retraitForm.value.telephone) {
            alert('Le téléphone, les 4 derniers chiffres et le code de retrait sont obligatoires.');
            return;
        }
        retraitLoading.value = true;
        try {
            const bloc4Clean = retraitForm.value.bloc4.replace(/\D/g, '').slice(-4);
            await axios.post(
                `/backoffice/users/${route.params.id}/cartes/${selectedCarte.value.id}/retrait`,
                {
                    bloc4: bloc4Clean,
                    code_retrait: retraitForm.value.code_retrait,
                    telephone: retraitForm.value.telephone,
                },
            );
            alert('Carte retirée avec succès.');
            retraitForm.value = { telephone: '', nom: '', prenom: '', numero_piece: '', bloc4: '', code_retrait: '' };
            await loadCartes();
        } catch (error: any) {
            alert(error.response?.data?.message || 'Erreur lors du retrait.');
        } finally {
            retraitLoading.value = false;
        }
    }

    function applyTxFilters() {
        txPage.value = 1;
        loadTransactions();
    }

    function changePage(page: number) {
        if (page < 1 || page > totalPages.value) return;
        txPage.value = page;
        loadTransactions();
    }

    function formatDateFrenchLong(dateString?: string | null): string {
        if (!dateString) return '-';
        const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        const date = moment(dateString);
        if (!date.isValid()) return '-';
        return `${date.format('DD')} ${monthsFr[date.month()]} ${date.year()}`;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "page-space-40" }, null, -1)),
    _cache[41] || (_cache[41] = _createElementVNode("h4", { class: "s7 font-semibold px-3 pb-5" }, [
      _createTextVNode("Membre / Carte "),
      _createElementVNode("span", { class: "text-sm text-grey-500" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: !!user.value.photo_url ? user.value.photo_url : '/assets/users_avatar/600w/user.jpg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1),
        _createElementVNode("h4", null, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h4", _hoisted_9, _toDisplayString(user.value.collectivite?.nom || 'N/A'), 1),
        (user.value.actif == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Actif"))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, "Inactif"))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (user.value.souscription?.date_fin)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_13, [
              _cache[11] || (_cache[11] = _createTextVNode(" Date de fin de souscription ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
              _createElementVNode("b", _hoisted_14, _toDisplayString(formatDateFrenchLong(user.value.souscription.date_fin)), 1)
            ]))
          : (_openBlock(), _createElementBlock("h4", _hoisted_15, [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" Date de fin de souscription ", -1),
              _createElementVNode("br", { class: "mb-2" }, null, -1),
              _createElementVNode("b", { class: "text-2xl" }, "-", -1)
            ]))]))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Solde", -1)),
          _createElementVNode("div", _hoisted_18, _toDisplayString(selectedCarte.value ? _unref(formatAmount)(selectedCarte.value.solde) + ' F' : '-'), 1)
        ])
      ])
    ]),
    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    (cartesLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Chargement des cartes..."))
      : (cartes.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Aucune carte associée à ce membre. "))
        : (selectedCarte.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open-flex active" }, [
                _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-open.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-open",
                    alt: ""
                  }),
                  _createElementVNode("img", {
                    src: "/icons/icon-panel-close.svg",
                    class: "size-xs icon-neutral mr-2 collapse-icon-close",
                    alt: ""
                  }),
                  _createTextVNode(" Carte ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                (selectedCarte.value.statut !== 'blocked')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-ultra lg shadow-200 color2",
                      disabled: blocking.value,
                      onClick: bloquerCarte
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["btn-show", { 'display-none': blocking.value }])
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-consulter.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Bloquer", -1)
                      ]))], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["btn-loading", { 'display-none': !blocking.value }])
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("div", { class: "loader-dots" }, null, -1)
                      ]))], 2)
                    ], 8, _hoisted_23))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, "Bloquée"))
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
              _createElementVNode("div", _hoisted_25, [
                (selectedCarte.value.statut === 'delivery')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "mb-2 px-5" }, "Retrait de carte", -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((retraitForm.value.telephone) = $event)),
                              type: "text",
                              class: "form-control-code my-0 px-8 py-5 bg-white rounded-100 text-left",
                              placeholder: "Numéro de téléphone du membre"
                            }, null, 512), [
                              [_vModelText, retraitForm.value.telephone]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((retraitForm.value.nom) = $event)),
                              type: "text",
                              class: "form-control-code my-0 px-8 py-5 bg-white rounded-100 text-left",
                              placeholder: "Nom"
                            }, null, 512), [
                              [_vModelText, retraitForm.value.nom]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((retraitForm.value.prenom) = $event)),
                              type: "text",
                              class: "form-control-code my-0 px-8 py-5 bg-white rounded-100 text-left",
                              placeholder: "Prénom"
                            }, null, 512), [
                              [_vModelText, retraitForm.value.prenom]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((retraitForm.value.numero_piece) = $event)),
                              type: "text",
                              class: "form-control-code my-0 px-8 py-5 bg-white rounded-100 text-left",
                              placeholder: "Numéro de la pièce d'identité"
                            }, null, 512), [
                              [_vModelText, retraitForm.value.numero_piece]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((retraitForm.value.bloc4) = $event)),
                              type: "text",
                              class: "form-control-code my-0 px-8 py-5 bg-white rounded-100 text-left",
                              placeholder: "Les 4 derniers chiffres de la carte",
                              maxlength: "4"
                            }, null, 512), [
                              [_vModelText, retraitForm.value.bloc4]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((retraitForm.value.code_retrait) = $event)),
                              type: "text",
                              class: "form-control-code my-0 px-8 py-5 bg-white rounded-100 text-left",
                              placeholder: "Code de retrait de la carte"
                            }, null, 512), [
                              [_vModelText, retraitForm.value.code_retrait]
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "btn-ultra lg w-100 shadow-0",
                            disabled: retraitLoading.value,
                            onClick: retraitCarte
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["btn-show", { 'display-none': retraitLoading.value }])
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("img", {
                                src: "/icons/icon-valider.svg",
                                class: "btn-icon",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Valider", -1)
                            ]))], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["btn-loading", { 'display-none': !retraitLoading.value }])
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("div", { class: "loader-dots" }, null, -1)
                            ]))], 2)
                          ], 8, _hoisted_36)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_37, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "s6_mobile" }, [
                    _createElementVNode("img", {
                      src: "/images/carte_coop.png",
                      alt: "Carte",
                      width: "100%",
                      class: "rounded-30"
                    })
                  ], -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex-center" }, [
                    _createElementVNode("hr", { class: "hr-vertical h-100p" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("h3", _hoisted_39, [
                      _cache[20] || (_cache[20] = _createTextVNode(" Carte   ", -1)),
                      (selectedCarte.value.statut === 'active')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Validé"))
                        : (selectedCarte.value.statut === 'blocked')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Bloquée"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(selectedCarte.value.statut), 1))
                    ]),
                    _createElementVNode("h4", _hoisted_43, "**** **** **** " + _toDisplayString(selectedCarte.value.bloc4 || '****'), 1),
                    _createElementVNode("h4", _hoisted_44, _toDisplayString(selectedCarte.value.banque?.nom || 'N/A'), 1),
                    (selectedCarte.value.created_at)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_45, " Créé le " + _toDisplayString(_unref(formatDate)(selectedCarte.value.created_at, 'DD MMM YYYY HH:mm')), 1))
                      : _createCommentVNode("", true),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
                    _createElementVNode("h4", _hoisted_46, "Référence / " + _toDisplayString(selectedCarte.value.reference || '-'), 1),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Solde disponible", -1)),
                    _createElementVNode("h4", _hoisted_47, _toDisplayString(_unref(formatAmount)(selectedCarte.value.solde)) + " F", 1)
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "flex-center" }, [
                    _createElementVNode("hr", { class: "hr-vertical h-100p" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("h3", _hoisted_49, [
                      _cache[24] || (_cache[24] = _createTextVNode("Retrait   ", -1)),
                      (selectedCarte.value.date_retrait)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Effectué"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_51, "En attente"))
                    ]),
                    (selectedCarte.value.date_retrait)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_52, " Retiré le " + _toDisplayString(_unref(formatDate)(selectedCarte.value.date_retrait, 'DD MMM YYYY HH:mm')), 1))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_53, "Carte non encore retirée")),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
                    (selectedCarte.value.num_lot)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_54, "N° de lot : " + _toDisplayString(selectedCarte.value.num_lot), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    (selectedCarte.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _cache[39] || (_cache[39] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Transactions </span></div><div class=\"clear-both h-5\"></div>", 2)),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((txReference).value = $event)),
                    type: "text",
                    class: "form-input",
                    name: "reference",
                    id: "reference",
                    placeholder: "",
                    onKeyup: _withKeys(applyTxFilters, ["enter"])
                  }, null, 544), [
                    [_vModelText, txReference.value]
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("label", { for: "reference" }, "Référence de transaction", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((txDateMin).value = $event)),
                    type: "date",
                    class: "form-input",
                    name: "date_min",
                    id: "date_min",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, txDateMin.value]
                  ]),
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "date_min" }, "Date >=", -1))
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("hr", { class: "hr sm" }, null, -1)),
                _createElementVNode("div", _hoisted_62, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((txDateMax).value = $event)),
                    type: "date",
                    class: "form-input",
                    name: "date_max",
                    id: "date_max",
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, txDateMax.value]
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("label", { for: "date_max" }, "Date <=", -1))
                ])
              ]),
              _createElementVNode("button", {
                class: "btn lg shadow-200 color2",
                onClick: applyTxFilters
              }, [...(_cache[35] || (_cache[35] = [
                _createElementVNode("span", null, "Filtrer", -1)
              ]))])
            ]),
            (transactionsLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, " Chargement des transactions... "))
              : (transactions.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, " Aucune transaction trouvée pour cette carte. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (tx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tx.id,
                        class: "flex gap-6 mb-4"
                      }, [
                        _cache[36] || (_cache[36] = _createElementVNode("div", {
                          class: "square-xl px-4 py-4",
                          style: {"background-color":"rgba(0, 185, 172, 0.08)"}
                        }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-trans-recharger.svg",
                            width: "100%",
                            class: "icon-neutral"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("h6", _hoisted_67, _toDisplayString(tx.libelle || tx.description || tx.reference || '-'), 1),
                          _createElementVNode("p", _hoisted_68, [
                            _createTextVNode(_toDisplayString(_unref(formatDate)(tx.created_at, 'DD MMM YYYY HH:mm')) + " ", 1),
                            (tx.reference)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_69, " - " + _toDisplayString(tx.reference), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("h5", {
                          class: _normalizeClass(["s5 secondary-font text-right mt-2", { 'text-green': tx.type === 'credit' }])
                        }, _toDisplayString(tx.type === 'credit' ? '+ ' : '- ') + _toDisplayString(_unref(formatAmount)(tx.montant)) + " F ", 3)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("button", {
                        class: "page-link",
                        disabled: txPage.value === 1,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (changePage(txPage.value - 1)))
                      }, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-pagination-prev.svg",
                          class: "pagination-icon",
                          alt: ""
                        }, null, -1),
                        _createTextVNode(" Précedent ", -1)
                      ]))], 8, _hoisted_71),
                      _createElementVNode("span", _hoisted_72, _toDisplayString(txPage.value) + " / " + _toDisplayString(totalPages.value), 1),
                      _createElementVNode("button", {
                        class: "page-link pl-4",
                        disabled: txPage.value >= totalPages.value,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (changePage(txPage.value + 1)))
                      }, [...(_cache[38] || (_cache[38] = [
                        _createTextVNode(" Suivant ", -1),
                        _createElementVNode("img", {
                          src: "/icons/icon-pagination-next.svg",
                          class: "pagination-icon ml-2",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_73)
                    ])
                  ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "clear-both h-80" }, null, -1))
  ]))
}
}

})